<script>

  import auth from '@/services/auth'
  const { signOut } = auth

  export default {
    name: 'SignOut',
    data () {
      return {}
    },
    methods: {
      async signOut () {
        try {
          await signOut()
        } catch (e) {
          console.log(e)
        } finally {
          this.$router.push({ name: 'login' })
        }
      },
    },
  }
</script>

<template lang="pug">

button.sign-out(type="button", @click="signOut") deconnexion
</template>

<style lang="postcss" scoped>


  .sign-out {
    border: none;
    background: none;
    text-decoration: underline;
    color: white;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// sign-out.vue?6d52bc08